module.exports = __webpack_public_path__ + "img/straight-rail-diagonal-right-top-stone-path-background-remnants.44711ad8.png";